export const INDICATOR_SETS_STORAGE_KEY = "vnsc:indicator-sets-v1";
